import React, { useCallback, useState, useEffect } from "react";
import { useDropzone } from "react-dropzone";
const API_URL = process.env.REACT_APP_API_BASE_URL;

const MAX_IMAGES = 7;

const MultipleImageUpload = ({
    itemMulImgArrayList,
    setItemMulImgArrayList,

    deleteItemMulImgArrayList,
    setDeleteItemMulImgArrayList,
}) => {
    // const [itemMulImgArrayList, setItemMulImgArrayList] = useState([]);
    const [error, setError] = useState("");

    const onDrop = useCallback((acceptedFiles) => {
        setError(""); // clear old error

        const remaining = MAX_IMAGES - itemMulImgArrayList.length;
        const filesToAdd = acceptedFiles.slice(0, remaining);

        const mappedFiles = filesToAdd.map(file =>
            Object.assign(file, {
                preview: URL.createObjectURL(file),
                img_url: file
            })
        );

        setItemMulImgArrayList(prev => [...prev, ...mappedFiles]);
    }, [itemMulImgArrayList]);

    // 🔥 THIS IS THE IMPORTANT FIX
    const onDropRejected = useCallback((fileRejections) => {
        if (fileRejections.length > 0) {
            setError(`Maximum ${MAX_IMAGES} itemMulImgArrayList allowed`);
        }
    }, []);

    const removeImage = (index) => {
        setItemMulImgArrayList(prevList => {
            // 🛑 safety check
            if (!prevList || !prevList[index]) return prevList;

            const copy = [...prevList];
            const removedImg = copy[index];

            // ✅ add ONLY valid DB images to delete list
            if (
                removedImg &&
                typeof removedImg.img_url === "string" &&
                removedImg.img_url.trim() !== ""
            ) {
                setDeleteItemMulImgArrayList(prevDelete =>
                    Array.isArray(prevDelete)
                        ? [...prevDelete, removedImg]
                        : [removedImg]
                );
            }

            // ✅ revoke preview only for newly added files
            if (removedImg.preview) {
                URL.revokeObjectURL(removedImg.preview);
            }

            // ✅ remove from UI list
            copy.splice(index, 1);
            return copy;
        });

        setError("");
    };



    useEffect(() => {
        return () => {
            itemMulImgArrayList.forEach(img => URL.revokeObjectURL(img.preview));
        };
    }, [itemMulImgArrayList]);

    const {
        getRootProps,
        getInputProps,
        isDragActive,
        isDragReject
    } = useDropzone({
        onDrop,
        onDropRejected, // ✅ REQUIRED
        accept: { "image/*": [] },
        multiple: true,
        maxFiles: MAX_IMAGES
    });

    return (
        <>
            {/* DROP AREA */}
            <div
                {...getRootProps()}
                style={{
                    border: isDragActive
                        ? "2px solid #198754"
                        : "2px dashed #0d6efd",
                    background: isDragActive
                        ? "#e6fffa"
                        : isDragReject
                            ? "#ffe6e6"
                            : "#f8f9fa",
                    padding: "40px",
                    borderRadius: "10px",
                    textAlign: "center",
                    cursor: "pointer",
                    minHeight: "140px"
                }}
            >
                <input {...getInputProps()} />

                {isDragActive ? (
                    <h5 className="text-success">✅ Drop itemMulImgArrayList here</h5>
                ) : (
                    <h6>
                        Drag & drop itemMulImgArrayList here <br />
                        <small className="text-muted">
                            Max {MAX_IMAGES} itemMulImgArrayList allowed
                        </small>
                    </h6>
                )}
            </div>

            {/* ✅ ERROR MESSAGE (NOW ALWAYS WORKS) */}
            {error && (
                <div
                    style={{
                        marginTop: "8px",
                        color: "#dc3545",
                        fontSize: "14px",
                        fontWeight: "500"
                    }}
                >
                    ⚠ {error}
                </div>
            )}

            {/* IMAGE PREVIEW */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
                    gap: "16px",
                    marginTop: "20px"
                }}
            >
                {itemMulImgArrayList.map((file, index) => (
                    <div
                        key={index}
                        style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            overflow: "hidden",
                            background: "#fff"
                        }}
                    >
                        <div
                            style={{
                                height: "140px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#f5f5f5"
                            }}
                        >
                            <img
                                // src={file.preview}
                                src={
                                    typeof file.img_url === "string"
                                        ? API_URL + file.img_url
                                        : file.preview
                                }
                                alt="preview"
                                style={{
                                    maxWidth: "100%",
                                    maxHeight: "100%",
                                    objectFit: "contain"
                                }}
                            />
                        </div>

                        <button
                            type="button"
                            onClick={() => removeImage(index)}
                            style={{
                                width: "100%",
                                border: "none",
                                background: "#dc3545",
                                color: "#fff",
                                padding: "8px",
                                cursor: "pointer"
                            }}
                        >
                            ❌ Remove
                        </button>
                    </div>
                ))}
            </div>
        </>
    );
};

export default MultipleImageUpload;
